import { render, staticRenderFns } from "./routePermissionList.vue?vue&type=template&id=7338f102&scoped=true&"
import script from "./routePermissionList.vue?vue&type=script&lang=js&"
export * from "./routePermissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7338f102",
  null
  
)

export default component.exports